import * as d3 from "d3";
import { atBqnTarget } from "common/api";

export const parseSystemDate = (input) => new Date(input);

export const parseFloatOrNull = (value) =>
  value === "n/a"
    ? null
    : value.endsWith("%") === true
    ? parseFloat((parseFloat(value.trim("%")) / 100).toFixed(4))
    : parseFloat(value);

export const parseProtocolsVolume = (input) => {
  const [head, ...rows] = input.trim("\n").split("\n");
  const keys = head.split(/\s+/).map(asJSAttribute);
  return rows.map((row) => Object.fromEntries(timeAndNumbers(row, keys)));
};

const dateTimeParser = d3.timeParse("%Y-%m-%dT%H:%M:%S");

const capitalizeFirstLetter = (word) =>
  word[0].toUpperCase() + word.slice(1).toLowerCase();

const lowerFirstUpperOthers = (word, index) =>
  index === 0 ? word.toLowerCase() : capitalizeFirstLetter(word);

const asJSAttribute = (input) =>
  input
    .split(/[\s-]+/)
    .map(lowerFirstUpperOthers)
    .join("");

const timeAndNumbers = (row, keys, skipped = []) =>
  row
    .split(/\s+/)
    .map((value, index) =>
      skipped.length > 0 && skipped.includes(keys[index])
        ? null
        : [
            keys[index],
            index > 0 ? parseFloatOrNull(value) : dateTimeParser(value),
          ]
    )
    .filter((item) => item !== null);

const listFieldNameAndLabel = (response) => {
  const [head] = response.trim("\n").split("\n", 1);
  return head
    .split(/\s+/)
    .map((label) => ({ label, name: asJSAttribute(label) }));
};

const polarizeByDirection = (direction) =>
  direction === "all"
    ? (item) => item
    : direction === "downlink"
    ? ({ name, label }) =>
        name.startsWith("up")
          ? null
          : { name, label: label.replace(/^DN-/, "") }
    : ({ name, label }) =>
        name.startsWith("dn")
          ? null
          : { name, label: label.replace(/^UP-/, "") };

const notTimeOrNull = (item) => item !== null && item.name !== "time";

export const getFieldsOnDirection = (direction) => (response) =>
  listFieldNameAndLabel(response)
    .map(polarizeByDirection(direction))
    .filter(notTimeOrNull);

export const getRowsBqn = (rows, mode, bqnId, headerIndex) => {
  if(mode==="standalone"){
    return rows;
  }
  if(bqnId==="all"){
    return [];
  }
  return rows.filter((row)=>{
    const rowAttrs = row.trim().split(/\s+/);
    return parseFloat(rowAttrs[headerIndex["BQN"]]) === parseFloat(bqnId);
  })
}

// The traffic of a sample is what all the series of it add up to, and the
// highest of them is what the chart reaches: the limit of a license far above
// it is not worth a line of its own, which would flatten the whole chart.
const sumFieldsTotal = (total, [field, value]) =>
  field === "time" ? total : total + value;

const getRecordTotal = (record) =>
  Object.entries(record).reduce(sumFieldsTotal, 0);

export const getMaxTotal = (items) => d3.max(items.map(getRecordTotal));

export const getLicenseLimit = (input, mode, bqnId) => {
  const [header, ...rows] = input.trim().split("\n");
  const headerAttrs = header.trim().split(/\s+/)
  const indexAttrMap = headerAttrs.reduce((acc, value, index)=>{
    acc[value]=index;
    return acc;
  }, {});

  const rowsBqn = getRowsBqn(rows, mode, bqnId, indexAttrMap);

  if(rowsBqn.length === 0){
    return null;
  }

  const attrs = rowsBqn[0].trim().split(/\s+/);
  const maxUsage = attrs[indexAttrMap["USAGE-MAX"]];
  return maxUsage === "n/a" ? null : parseInt(maxUsage);
};


// The data of the BQN selected in the header, or of the whole cluster.

export const protocolsVolumeRetrieval = ({
  hours = 72,
  interval,
  protocols = "none",
  mode,
  bqnId,
}) =>
  ifCl.run(
    atBqnTarget(
      `show statistics volume mbps-max hours ${hours} interval ${interval} grouped-by ${protocols}`,
      mode,
      bqnId
    )
  );

export const licenseRetrieval = (mode, bqnId) =>
  ifCl.run(atBqnTarget("show license", mode, bqnId));
